import { render } from "./InsuranceInformation.vue?vue&type=template&id=0af1a0b2"
import script from "./InsuranceInformation.vue?vue&type=script&lang=js"
export * from "./InsuranceInformation.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./InsuranceInformation.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_60841141%2Fpackages%2Fcustomer%2Fsrc%2Fviews%2Fplan%2FInsuranceInformation.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__